import { Row, Col } from 'react-bootstrap';
import styled from 'styled-components';

export const Container = styled(Row)`
  font-family: "Roboto";
  border-top: 1px solid #dfe1e4;
  padding: 1em 0;
  .info {
    font-size: 13px;
  }

  &:hover {
    background-color: rgba(206, 206, 206);
  }
`;

export const StyledCol = styled(Col)`
  @media screen and (max-width: 414px) {
    width: 100%;
  }
`

export const ProfileTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  a {
    color: #337ab7;
    &:hover {
      text-decoration: none;
    }
  }
`
